import { Button, ClearButton } from '@shared/components/Button';
import { Text } from '@shared/components/Text';
import { ButtonView, View } from '@shared/components/View';
import { Subform } from '@shared/data/entity/fields/SubformField';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { i18n } from '@shared/util/i18n';
import { countCompletedSubformFields } from './hooks';
import styles from './SubformsContent.module.css';

interface Props {
  subform: Subform;
  onSelect: (workflowTemplateId: string) => void;
  onClear: VoidFunction;
  isReadOnly?: boolean;
}

export function SubformContent({ subform, onSelect, onClear, isReadOnly }: Props) {
  const { workflowTemplate } = useWorkflowTemplate(subform.workflowTemplateId);
  const completedFields = countCompletedSubformFields(
    workflowTemplate?.components ?? [],
    subform.data,
  );
  const actionLabel = i18n(
    isReadOnly ? 'card.blocks.subformsInput.view' : 'card.blocks.subformsInput.start',
  );

  return (
    <View fill flex className={styles.cardContainer}>
      <ButtonView
        onClick={() => onSelect(subform.workflowTemplateId)}
        className={styles.subformContentButton}
        aria-label={actionLabel}
      />
      {!isReadOnly && (
        <View className={styles.clearButton}>
          <ClearButton onClick={onClear} />
        </View>
      )}
      <View>
        <Text size="body1" weight="semibold">
          {workflowTemplate?.name}
        </Text>
        <View paddingTop={0.5}>
          <Text size="body2">
            {i18n('card.blocks.subformsInput.fieldsCompleted', { count: completedFields })}
          </Text>
        </View>
      </View>
      <View paddingTop={1.5} row={true} marginLeft={-0.5}>
        <Button
          variant="primary"
          size="medium"
          label={actionLabel}
          onClick={() => onSelect(subform.workflowTemplateId)}
        />
      </View>
    </View>
  );
}
